import React from "react";
import RightIcon from "../../Images/icons/tick.png";
import Us from "../../Images/icons/circle 1.png";
import { useTheme } from "../BrandColors/Context/ThemeContext";

const plansData = [
  {
    title: "Trial",
    price: "$0",
    perMonth: true,
    features: [
      "5 minutes of video factory",
      "5 minutes live streaming",
      "Full Screen Watermark",
      "Limited Support",
    ],
    options: ["1 year at $0/month", "1 year at $2/month", "1 year at $4/month"],
    isFeatured: false,
  },
  {
    title: "Pro plan",
    price: "$500.68",
    perMonth: true,
    features: [
      "120 minutes of video recording",
      "240 minutes of live streaming videos",
      "Video Translate",
      "AI Watermark",
      "Gold Support",
    ],
    options: [
      "1 year at $500.68/month",
      "2 year at $499.88/month",
      "2 year at $497.34/month",
    ],
    isFeatured: true,
  },
  {
    title: "Enterprise",
    price: "Let's talk",
    perMonth: false,
    features: [
      "Unlimited mins of video",
      "Unlimited mins of streaming video",
      "Video Translate",
      "Custom Watermark",
      "Premium Support",
    ],
    options: [
      "1 year at $800.98/month",
      "2 year at $799.88/month",
      "2 year at $795.34/month",
    ],
    isFeatured: false,
  },
];

const SubscriptionPlans = () => {
  const phoneNumber = 9351862675;
  const theme = useTheme() || "#3b82f6";
  
  const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <div className="w-full flex flex-col items-center py-12 px-6 animate-fade-in-up">
      
      {/* Location Selector */}
      <div className="glass-panel py-2 px-4 rounded-full flex items-center gap-3 mb-8 border border-blue-200/50 shadow-lg">
        <span className="w-6 h-6 rounded-full overflow-hidden flex-shrink-0">
          <img src={Us} alt="US Flag" className="w-full h-full object-cover" />
        </span>
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-white">US</span>
          <select className="bg-transparent text-sm text-slate-700 border-none outline-none cursor-pointer hover:text-white transition-colors">
            <option className="bg-blue-50 text-slate-700">Texas</option>
            <option className="bg-blue-50 text-slate-700">California</option>
            <option className="bg-blue-50 text-slate-700">Florida</option>
            <option className="bg-blue-50 text-slate-700">New York</option>
            <option className="bg-blue-50 text-slate-700">Nevada</option>
          </select>
        </div>
      </div>

      <div className="text-center mb-12 max-w-2xl">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
          Select a plan that suits you salesense product
        </h2>
        <p className="text-lg text-slate-600">
          Our salesense product
        </p>
      </div>

      <div className="w-full max-w-7xl grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
        {plansData.map((plan, index) => (
          <div
            key={index}
            className={`glass-panel p-8 rounded-3xl flex flex-col transition-all duration-300 relative overflow-hidden group hover:-translate-y-2
              ${plan.isFeatured ? 'border-2 shadow-[0_10px_40px_rgba(var(--theme-color-rgb),0.2)]' : 'border border-blue-200/50 shadow-xl'}
            `}
            style={plan.isFeatured ? { borderColor: theme, boxShadow: `0 10px 40px ${theme}30` } : {}}
          >
            
            {/* Featured decorative background */}
            {plan.isFeatured && (
              <div 
                className="absolute top-0 left-0 w-full h-1 opacity-100"
                style={{ backgroundColor: theme }}
              />
            )}

            <div className="mb-8 border-b border-blue-200/50 pb-8 flex-grow">
              <h3 className="text-xl font-semibold text-slate-700 mb-4">{plan.title}</h3>
              
              <div className="min-h-[80px] flex items-end">
                {plan.perMonth ? (
                  <div>
                    <span className="text-5xl font-bold text-white tracking-tight">{plan.price}</span>
                    <span className="text-sm text-slate-600 ml-2">Per month</span>
                  </div>
                ) : (
                  <button 
                    onClick={handleCall}
                    className="text-4xl font-bold tracking-tight hover:underline transition-all cursor-pointer inline-block"
                    style={{ color: theme }}
                  >
                    {plan.price}
                  </button>
                )}
              </div>
            </div>

            <ul className="flex flex-col gap-4 mb-8 flex-grow">
              {plan.features.map((feature, idx) => (
                <li key={idx} className="flex items-start gap-3 text-sm text-slate-700">
                  <span className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 bg-green-500/20 mt-0.5">
                    <img src={RightIcon} alt="Tick" className="w-2.5 h-2.5 opacity-80 filter brightness-200" />
                  </span>
                  <span className="leading-snug">{feature}</span>
                </li>
              ))}
            </ul>

            <div className="mt-auto pt-6 border-t border-blue-200/50 flex flex-col gap-4">
              <div className="relative">
                <select className="w-full bg-blue-50 border border-blue-200 text-slate-700 text-sm rounded-xl py-3 px-4 outline-none focus:border-slate-500 transition-colors appearance-none cursor-pointer">
                  {plan.options.map((option, idx) => (
                    <option key={idx} className="bg-blue-50 text-slate-700 py-2">
                      {option}
                    </option>
                  ))}
                </select>
                <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none text-slate-600">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                </div>
              </div>
              
              <button 
                className={`w-full py-4 rounded-xl font-bold text-sm transition-all duration-300 transform active:scale-95 shadow-lg
                  ${plan.isFeatured 
                    ? 'text-white hover:brightness-110' 
                    : 'bg-white text-slate-700 border border-blue-200 hover:bg-blue-100 hover:text-white hover:border-slate-600'
                  }
                `}
                style={plan.isFeatured ? { backgroundColor: theme } : {}}
              >
                Select Plan
              </button>
            </div>
            
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPlans;
